<template>
  <div class="app-container">
    <!-- 1. 顶部筛选栏 -->
    <el-card class="box-card" style="margin-bottom: 10px">
      <div class="filter-bar">
        <div class="filter-item">
          <span class="label">{{ $t('trajectory.Time') }}</span>
          <el-date-picker
            v-model="queryParams.date"
            :placeholder="$t('operationCenter.SelectDate')"
            size="small"
            style="width: 200px"
            type="date"
            value-format="yyyy-MM-dd"
          />
        </div>
        <div class="filter-item">
          <span class="label">{{ $t('routes.equipmentTitle') }}</span>
          <el-select
            v-model="queryParams.machineId"
            :placeholder="$t('dictionary.pleaseChoose')"
            filterable
            size="small"
            style="width: 200px"
            @change="handleDeviceChange"
          >
            <el-option
              v-for="item in machineList"
              :key="item.id"
              :label="item.machineName"
              :value="item.id"
            />
          </el-select>
        </div>
        <div class="filter-item">
          <span class="label">{{ $t('newOperationCenter.rule') }}</span>
          <el-select
            v-model="queryParams.ruleId"
            :placeholder="$t('dictionary.pleaseChoose')"
            clearable
            filterable
            size="small"
            style="width: 200px"
          >
            <el-option
              v-for="item in ruleList"
              :key="item.id"
              :label="item.ruleName"
              :value="item.id"
            />
          </el-select>
        </div>
        <div class="filter-actions">
          <el-button
            icon="el-icon-search" size="small" type="success"
            @click="searchBtn"
          >{{ $t('collectionCenter.search') }}
          </el-button>
          <el-button
            icon="el-icon-refresh" plain size="small"
            type="success" @click="handleReset"
          >{{ $t('collectionCenter.reset') }}
          </el-button>
        </div>
      </div>
    </el-card>
    <!-- 2. 顶部统计卡片 -->
    <el-card class="box-card" style="margin-bottom: 10px">
      <div class="stat-cards">
        <!-- 卡片 1：格口总数 -->
        <div class="stat-card">
          <div class="stat-info">
            <div class="row">
              <span>{{ $t('CenterForSorting.totalChutes') }}</span><span class="num">{{ kanbanBoard.totalChuteCount || '--' }}</span>
            </div>
            <div class="row">
              <span>{{ $t('newOperationCenter.usedCompartment') }}</span><span class="num">{{ kanbanBoard.userChuteCount || '--' }}</span>
            </div>
            <div class="row">
              <span>{{ $t('newOperationCenter.emptyCompartment') }}</span><span class="num">{{ kanbanBoard.unUserChuteCount || '--' }}</span>
            </div>
          </div>
          <div class="stat-chart">
            <el-progress
              :percentage="kanbanBoard.utilizationRateNum"
              :width="100"
              color="#13ce66"
              type="circle"
            />
            <div class="chart-label">{{ $t('newOperationCenter.utilizationRate') }}</div>
          </div>
        </div>

        <!-- 卡片 2：正常/异常格口数 -->
        <div class="stat-card">
          <div class="stat-info">
            <div class="row">
              <span>{{ $t('newOperationCenter.normalCompartmentCount') }}</span><span class="num">{{ kanbanBoard.normalChuteCount }}</span>
            </div>
            <div class="row">
              <span>{{ $t('newOperationCenter.abnormalCompartmentCount') }}</span><span class="num">{{ kanbanBoard.abnormalChuteCount }}</span>
            </div>
          </div>
        </div>

        <!-- 卡片 3：正常/异常落袋包裹量 -->
        <div class="stat-card">
          <div class="stat-info">
            <div class="row">
              <span>{{ $t('newOperationCenter.normalBagDropCount') }}</span><span class="num">{{ kanbanBoard.normalPackageRate }}</span>
            </div>
            <div class="row">
              <span>{{ $t('newOperationCenter.abnormalBagDropCount') }}</span><span class="num">{{ kanbanBoard.abnormalPackageRate }}</span>
            </div>
          </div>
        </div>
      </div>
    </el-card>

    <!-- 3. 正常分拣货量统计 (带展开行) -->
    <div class="table-section">
      <div class="section-header">
        <div class="title">
          <i class="el-icon-s-grid green-icon" />
          {{ $t('newOperationCenter.normalSortingVolumeStats') }}
        </div>
        <el-button
          class="expand-all-btn" size="mini" type="text"
          @click="toggleExpandAll"
        >
          {{
            isTableExpanded
              ? $t('newOperationCenter.collapseAll')
              : $t('newOperationCenter.expandAll')
          }}
        </el-button>
      </div>
      <el-table
        ref="normalTable"
        :data="normalTableData"
        :tree-props="{ children: 'detailDataList' }"
        border
        row-key="id"
        style="width: 100%; margin-bottom: 20px"
      >
        <el-table-column :label="$t('CenterForSorting.sortingRuleName')">
          <template slot-scope="{ row }">
            {{ row.ruleName }}
          </template>
        </el-table-column>
        <el-table-column :label="$t('CenterForSorting.chuteNum')" align="center" prop="chuteData">
          <template slot-scope="scope">
            <!-- 如果是 number 类型，渲染 div -->
            <div v-if="typeof scope.row.chuteData === 'number'">
              {{ scope.row.chuteData }}
            </div>
            <!-- 否则渲染 el-tag -->
            <el-tag v-if="typeof scope.row.chuteData === 'string'" size="mini" type="primary">
              {{ scope.row.chuteData }}
            </el-tag>
            <div v-else />
          </template>
        </el-table-column>
        <el-table-column
          :label="$t('newOperationCenter.preDeliveryHubCount')"
          align="center"
          prop="preDeliverySiteData"
        />
        <el-table-column
          :label="$t('trajectory.NumberPackages')"
          align="center"
          prop="packageCount"
        />
        <el-table-column
          :label="$t('newOperationCenter.normalBagDropRatio')"
          align="center"
          prop="countRate"
        />
      </el-table>
    </div>

    <!-- 4. 异常分拣货量统计 -->
    <div class="table-section" style="margin-top: 10px">
      <div class="section-header">
        <div class="title">
          <i class="el-icon-document green-icon" />
          {{ $t('newOperationCenter.abnormalSortingVolumeStats') }}
        </div>
      </div>
      <el-table
        :data="errorTableData"
        border
        header-cell-class-name="table-header-gray"
        stripe
        style="width: 100%"
      >
        <el-table-column
          :label="$t('CenterForSorting.sortingRuleName')"
          align="center"
          prop="ruleName"
        />
        <el-table-column :label="$t('CenterForSorting.chuteNo')" align="center">
          <template slot-scope="scope">
            <el-tag size="mini" type="primary">{{ scope.row.chuteNumber }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column
          :label="$t('newOperationCenter.NumberPackages')"
          align="center"
          prop="packageCount"
        />
        <el-table-column
          :label="$t('newOperationCenter.abnormalBagDropRatio')"
          align="center"
          prop="countRate"
        />
      </el-table>
    </div>
  </div>
</template>

<script>
import {
  abnormalPackage,
  cargoCountStatistie,
  GetMachineList,
  getRuleList,
  normalPackage
} from '@/api/sorting/machine';
import dayjs from 'dayjs';

export default {
  name: 'DashboardPage',
  data() {
    return {
      // 筛选表单数据
      queryParams: {
        date: dayjs().format('YYYY-MM-DD'),
        machineId: '',
        ruleId: ''
      },
      // 正常分拣表格数据
      normalTableData: [],
      // 异常分拣表格数据
      errorTableData: [],
      machineList: [],
      ruleList: [],
      kanbanBoard: {},
      isTableExpanded: false
    };
  },
  created() {
    this.getMachineList();
  },
  methods: {
    /**
     * 构建统一的查询参数
     */
    buildQueryData() {
      return {
        date: this.queryParams.date || '',
        machineId: this.queryParams.machineId || '',
        ruleId: this.queryParams.ruleId || ''
      };
    },

    // 点击查询按钮：同时请求三项数据
    async searchBtn() {
      if (!this.queryParams.date) {
        this.$message.error(this.$t('collectionCenter.selectDate'));
        return;
      }
      const queryData = this.buildQueryData();
      await Promise.all([
        this.fetchKanbanBoard(queryData),
        this.fetchNormalPackage(queryData),
        this.fetchAbnormalPackage(queryData)
      ]);
    },

    // 重置筛选条件
    handleReset() {
      this.queryParams.date = dayjs().format('YYYY-MM-DD');
      this.queryParams.ruleId = '';
      this.getMachineList();
    },

    // 看板统计卡片
    async fetchKanbanBoard(data) {
      try {
        const res = await cargoCountStatistie(data);
        if (res && res.data) {
          this.kanbanBoard = res.data;
          const total = this.kanbanBoard.totalChuteCount || 0;
          const used = this.kanbanBoard.userChuteCount || 0;
          let utilizationRate = 0;
          if (total > 0) {
            utilizationRate = ((used / total) * 100).toFixed(1);
          }
          this.kanbanBoard.utilizationRateStr = `${utilizationRate}%`;
          this.kanbanBoard.utilizationRateNum = parseFloat(utilizationRate);
        }
      } catch (e) {
        console.error('看板数据获取失败:', e);
      }
    },

    // 正常分拣货量
    async fetchNormalPackage(data) {
      try {
        const res = await normalPackage(data);
        if (res && res.data) {
          this.normalTableData = this.addTreeIds(res.data);
        }
      } catch (e) {
        console.error('正常分拣数据获取失败:', e);
      }
    },

    // 异常分拣货量
    async fetchAbnormalPackage(data) {
      try {
        const res = await abnormalPackage(data);
        if (res && res.data) {
          this.errorTableData = res.data;
        }
      } catch (e) {
        console.error('异常分拣数据获取失败:', e);
      }
    },

    // 全部展开/折叠
    toggleExpandAll() {
      this.isTableExpanded = !this.isTableExpanded;
      this.$nextTick(() => {
        this.toggleRows(this.normalTableData, this.isTableExpanded);
      });
    },

    toggleRows(rows, expanded) {
      const table = this.$refs.normalTable;
      if (!table) return;
      rows.forEach((row) => {
        table.toggleRowExpansion(row, expanded);
        if (row.detailDataList && row.detailDataList.length) {
          this.toggleRows(row.detailDataList, expanded);
        }
      });
    },

    /**
     * 递归为树形数据注入唯一 id
     */
    addTreeIds(list, counter = { val: 1 }) {
      return list.map((item) => {
        const row = { ...item, id: counter.val++ };
        if (row.detailDataList && row.detailDataList.length) {
          row.detailDataList = this.addTreeIds(row.detailDataList, counter);
        }
        return row;
      });
    },

    // 获取设备列表
    getMachineList() {
      GetMachineList().then((res) => {
        if (!res.data || !res.data.length) {
          return;
        }
        this.machineList = res.data;
        const obj = this.machineList.find((item) => item.machineCode === 'AJ-GRU');
        if (obj) {
          this.queryParams.machineId = obj.id;
          this.searchBtn();
          this.handleDeviceChange(this.queryParams.machineId);
        }
      });
    },

    // 根据设备id查询配置规则
    async handleDeviceChange(machineId) {
      this.queryParams.ruleId = '';
      if (machineId) {
        const res = await getRuleList(machineId);
        this.ruleList = res.data;
        await this.searchBtn();
      } else {
        this.ruleList = [];
      }
    }
  }
};
</script>

<style scoped>
/* --- 1. 筛选栏 --- */
.filter-bar {
  display: flex;
  align-items: center;
}

.filter-item {
  display: flex;
  align-items: center;
  margin-right: 20px;
}

.filter-item .label {
  color: #606266;
  font-size: 14px;
  margin-right: 10px;
}

.filter-actions {
  margin-left: auto;
}

/* --- 2. 统计卡片 --- */
.stat-cards {
  display: flex;
  gap: 20px;
}

.stat-card {
  flex: 1;
  border: 1px solid #ebeef5;
  border-radius: 4px;
  padding: 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 100px;
  position: relative;
}

/* 模拟绿色左边界 */
.stat-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 4px;
  background: #00a651;
  border-radius: 4px 0 0 4px;
}

.stat-info {
  flex: 1;
}

.stat-info .row {
  display: flex;
  justify-content: space-between;
  margin-bottom: 8px;
  font-size: 14px;
  margin-right: 20px;
  color: #333;
}

.stat-info .row:last-child {
  margin-bottom: 0;
}

.stat-info .num {
  font-weight: bold;
  color: #303133;
}

.stat-chart {
  position: relative;
  width: 80px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.stat-chart .chart-label {
  position: absolute;
  font-size: 10px;
  color: #909399;
  top: 20px;
}

/* --- 3. 表格区域 --- */
.table-section {
  background: #fff;
  border: 1px solid #ebeef5;
  border-radius: 4px;
  padding: 15px;
}

.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
}

.section-header .title {
  font-size: 16px;
  font-weight: bold;
  color: #303133;
}

.green-icon {
  color: #13ce66;
  font-size: 18px;
  margin-right: 5px;
}

.expand-all-btn {
  color: #409eff;
}

/* 表头背景色 */
::v-deep .table-header-gray {
  background-color: #f5f7fa !important;
  color: #606266;
  font-weight: bold;
}

/* 展开行子表格容器 */
.expand-table-container {
  padding: 10px 40px;
  background-color: #fafafa;
}

/* 响应式调整 */
@media screen and (max-width: 1200px) {
  .stat-cards {
    flex-wrap: wrap;
  }

  .stat-card {
    flex: 1 1 100%;
  }
}
</style>
